import request from '@/utils/request'

export const API_BASE_URL = process.env.VUE_APP_API_BASE_URL || '/api'

// 登录相关
export function getCaptcha() {
    return request({ url: '/auth/captcha', method: 'get' })
}
export function login(data) {
    return request({ url: '/auth/login', method: 'post', data })
}
export function getUserRoutes() {
    return request({ url: '/menu/user-routes', method: 'get' })
}
// 获取菜单列表
export function getMenuList() {
    return request({ url: '/menu/list', method: 'get' })
}

// 保存菜单 (新增或修改)
export function saveMenu(data) {
    // 后端现在统一用 /save 接口
    return request({ url: '/menu/save', method: 'post', data })
}

// 删除菜单
export function deleteMenu(data) {
    return request({ url: '/menu/delete', method: 'post', data })
}

// 用户相关
export function getUserList(params) {
    return request({ url: '/user/list', method: 'get', params })
}
export function addUser(data) {
    return request({ url: '/user/add', method: 'post', data })
}
export function updateUser(data) {
    return request({ url: '/user/update', method: 'put', data })
}
export function deleteUser(data) {
    return request({ url: '/user/delete', method: 'post', data })
}
export function resetUserPassword(data) {
    return request({ url: '/user/reset-password', method: 'post', data })
}
export function getUser(id) {
    return request({ url: `/user/${id}`, method: 'get' })
}
// 商城注册用户
export function getMallUserList(params) {
    return request({ url: '/mall-user/list', method: 'get', params })
}
// 角色列表（添加用户时用）
export function getRoleList() {
    return request({ url: '/role/list', method: 'get' })
}
export function getRoleMenuIds(id) {
    return request({ url: `/role/${id}/menu-ids`, method: 'get' })
}
export function assignRoleMenus(data) {
    return request({ url: '/role/assign-menus', method: 'post', data })
}
export function deleteRole(data) {
    return request({ url: '/role/delete', method: 'post', data })
}






// === 首页组件管理 (CMS) ===

// 1. 获取组件列表
export function getCmsComponents() {
    return request({ url: '/cms/home/list', method: 'get' })
}

// 2. 保存/更新组件
export function saveCmsComponent(data) {
    return request({ url: '/cms/home/save', method: 'post', data })
}

// 3. 保存排序 (拖拽后调用)
// data 格式示例: [3, 1, 5, 2] (ID数组)
export function sortCmsComponents(data) {
    return request({ url: '/cms/home/sort', method: 'post', data })
}

// 4. 删除组件
export function deleteCmsComponent(data) {
    return request({ url: '/cms/home/delete', method: 'post', data })
}
// === 产品管理 ===
export function getProductList(params) {
    return request({ url: '/product/list', method: 'get', params })
}
export function getProduct(id) {
    return request({ url: `/product/${id}`, method: 'get' })
}
export function saveProduct(data) {
    return request({ url: '/product/save', method: 'post', data })
}
export function deleteProduct(data) {
    return request({ url: '/product/delete', method: 'post', data })
}
export function updateProductStatus(data) {
    return request({ url: '/product/status', method: 'post', data })
}
export function importProducts(file, createMissingCategories = false, imageMappings = {}, fileMappings = {}, allowMissingAssets = false) {
    const data = new FormData()
    data.append('file', file)
    data.append('createMissingCategories', String(createMissingCategories))
    data.append('imageMappings', JSON.stringify(imageMappings))
    data.append('fileMappings', JSON.stringify(fileMappings))
    data.append('allowMissingAssets', String(allowMissingAssets))
    return request({ url: '/product/import', method: 'post', data, timeout: 60000 })
}
export function uploadProductImportImage(file) {
    const data = new FormData()
    data.append('file', file)
    return request({ url: '/upload/image', method: 'post', data, timeout: 30000 })
}
export function uploadProductImportFile(file) {
    const data = new FormData()
    data.append('file', file)
    return request({ url: '/upload/file', method: 'post', data, timeout: 30000 })
}
export function getProductImportTemplate() {
    return request({ url: '/product/import-template', method: 'get', responseType: 'blob', timeout: 30000 })
}

// === 字典管理 ===
export function getDictList(params) {
    return request({ url: '/dict/list', method: 'get', params })
}
export function saveDict(data) {
    return request({ url: '/dict/save', method: 'post', data })
}
export function deleteDict(data) {
    return request({ url: '/dict/delete', method: 'post', data })
}

// === 日志管理 ===
export function getLogList(params) {
    return request({ url: '/log/list', method: 'get', params })
}

// === 数据看板 ===
export function getDashboardStats() {
    return request({ url: '/dashboard/stats', method: 'get' })
}
export function getUserActivityList(params) {
    return request({ url: '/analytics/activity/list', method: 'get', params })
}
export function getSearchRanking(params) {
    return request({ url: '/analytics/search-ranking', method: 'get', params })
}

// === 产品参数 ===
export function getProductCategoryList(params) {
    return request({ url: '/product/category/list', method: 'get', params })
}
export function getProductCategoryTree() {
    return request({ url: '/product/category/tree', method: 'get' })
}
export function saveProductCategory(data) {
    return request({ url: '/product/category/save', method: 'post', data })
}
export function deleteProductCategory(data) {
    return request({ url: '/product/category/delete', method: 'post', data })
}
export function getProductCategoryGroupList() {
    return request({ url: '/product/category-group/list', method: 'get' })
}
export function saveProductCategoryGroup(data) {
    return request({ url: '/product/category-group/save', method: 'post', data })
}
export function deleteProductCategoryGroup(data) {
    return request({ url: '/product/category-group/delete', method: 'post', data })
}

// === 产品参数 ===
export function getProductParamList(params) {
    return request({ url: '/product/param/list', method: 'get', params })
}
export function saveProductParam(data) {
    return request({ url: '/product/param/save', method: 'post', data })
}
export function deleteProductParam(data) {
    return request({ url: '/product/param/delete', method: 'post', data })
}

// === 产品文件 ===
export function getProductFileList(params) {
    return request({ url: '/product/file/list', method: 'get', params })
}
export function saveProductFile(data) {
    return request({ url: '/product/file/save', method: 'post', data })
}
export function deleteProductFile(data) {
    return request({ url: '/product/file/delete', method: 'post', data })
}

// === 订单管理 ===
export function getOrderList(params) {
    return request({ url: '/order/list', method: 'get', params })
}
export function exportOrderList(params) {
    return request({ url: '/order/export', method: 'get', params, responseType: 'blob', timeout: 60000 })
}
export function saveOrder(data) {
    return request({ url: '/order/save', method: 'post', data })
}
export function deleteOrder(data) {
    return request({ url: '/order/delete', method: 'post', data })
}
export function getOrderDetail(id) {
    return request({ url: `/order/${id}`, method: 'get' })
}
export function downloadOrderContract(id) {
    return request({ url: `/order/${id}/contract`, method: 'get', responseType: 'blob', timeout: 30000 })
}
export function shipOrder(id, data) {
    return request({ url: `/order/${id}/ship`, method: 'post', data })
}
export function retryWechatOrderShipping(id) {
    return request({ url: `/order/${id}/wechat-shipping/retry`, method: 'post' })
}
export function appendOrderLogistics(id, data) {
    return request({ url: `/order/${id}/logistics`, method: 'post', data })
}
export function approveOrderRefund(refundId) {
    return request({ url: `/order/refund/${refundId}/approve`, method: 'post' })
}
export function rejectOrderRefund(refundId, data) {
    return request({ url: `/order/refund/${refundId}/reject`, method: 'post', data })
}
export function refreshOrderRefund(refundId) {
    return request({ url: `/order/refund/${refundId}/refresh`, method: 'post' })
}

// === 发票开具 ===
export function getInvoiceList(params) {
    return request({ url: '/invoice/list', method: 'get', params })
}
export function exportInvoiceList(params) {
    return request({ url: '/invoice/export', method: 'get', params, responseType: 'blob', timeout: 60000 })
}
export function saveInvoice(data) {
    return request({ url: '/invoice/save', method: 'post', data })
}
export function deleteInvoice(data) {
    return request({ url: '/invoice/delete', method: 'post', data })
}

// === 优惠券管理 ===
export function getCouponList(params) {
    return request({ url: '/coupon/list', method: 'get', params })
}
export function saveCoupon(data) {
    return request({ url: '/coupon/save', method: 'post', data })
}
export function deleteCoupon(data) {
    return request({ url: '/coupon/delete', method: 'post', data })
}

// === 积分产品 ===
export function getPointsGiftList(params) {
    return request({ url: '/points/gift/list', method: 'get', params })
}
export function savePointsGift(data) {
    return request({ url: '/points/gift/save', method: 'post', data })
}
export function deletePointsGift(data) {
    return request({ url: '/points/gift/delete', method: 'post', data })
}

// === 积分兑换 ===
export function getPointsExchangeList(params) {
    return request({ url: '/points/exchange/list', method: 'get', params })
}
export function savePointsExchange(data) {
    return request({ url: '/points/exchange/save', method: 'post', data })
}
export function deletePointsExchange(data) {
    return request({ url: '/points/exchange/delete', method: 'post', data })
}
export function shipPointsExchange(id, data) {
    return request({ url: `/points/exchange/${id}/ship`, method: 'post', data })
}
export function closePointsExchange(id, data) {
    return request({ url: `/points/exchange/${id}/close`, method: 'post', data })
}

// === PC 新闻管理 ===
export function getPcNewsList(params) {
    return request({ url: '/pc-news/list', method: 'get', params })
}
export function getPcNews(id) {
    return request({ url: `/pc-news/${id}`, method: 'get', timeout: 30000 })
}
export function savePcNews(data) {
    return request({ url: '/pc-news/save', method: 'post', data })
}
export function deletePcNews(data) {
    return request({ url: '/pc-news/delete', method: 'post', data })
}
export function getPcVideoList(params) {
    return request({ url: '/pc-video/list', method: 'get', params })
}
export function savePcVideo(data) {
    return request({ url: '/pc-video/save', method: 'post', data })
}
export function deletePcVideo(data) {
    return request({ url: '/pc-video/delete', method: 'post', data })
}

// === 商城基础设置 ===
export function getMallBasicSetting() {
    return request({ url: '/mall/setting/basic', method: 'get' })
}
export function saveMallBasicSetting(data) {
    return request({ url: '/mall/setting/basic', method: 'post', data })
}
export function getPointsRule() {
    return request({ url: '/mall/setting/points-rule', method: 'get' })
}
export function savePointsRule(data) {
    return request({ url: '/mall/setting/points-rule', method: 'post', data })
}

// === 合同模板 ===
export function getContractTemplateList(params) {
    return request({ url: '/contract/template/list', method: 'get', params })
}
export function saveContractTemplate(data) {
    return request({ url: '/contract/template/save', method: 'post', data })
}
export function deleteContractTemplate(data) {
    return request({ url: '/contract/template/delete', method: 'post', data })
}
export function getContractOpenRecordList(params) {
    return request({ url: '/contract/open-record/list', method: 'get', params })
}

// === 快递管理 ===
export function getExpressCompanyList(params) {
    return request({ url: '/express/company/list', method: 'get', params })
}
export function saveExpressCompany(data) {
    return request({ url: '/express/company/save', method: 'post', data })
}
export function deleteExpressCompany(data) {
    return request({ url: '/express/company/delete', method: 'post', data })
}
export function getFreightSetting() {
    return request({ url: '/express/freight/setting', method: 'get' })
}
export function saveFreightSetting(data) {
    return request({ url: '/express/freight/setting', method: 'post', data })
}
export function getFreightCompanies() {
    return request({ url: '/express/freight/companies', method: 'get' })
}
export function saveFreightCompany(data) {
    return request({ url: '/express/freight/company/save', method: 'post', data })
}
export function deleteFreightCompany(data) {
    return request({ url: '/express/freight/company/delete', method: 'post', data })
}

// === BOM 报价 ===
export function getBomQuoteList(params) {
    return request({ url: '/bom-quote/list', method: 'get', params })
}
export function saveBomQuote(data) {
    return request({ url: '/bom-quote/save', method: 'post', data })
}
export function deleteBomQuote(data) {
    return request({ url: '/bom-quote/delete', method: 'post', data })
}
export function getBomRecordList(params) {
    return request({ url: '/bom-record/list', method: 'get', params })
}
export function getBomRecordDetail(id) {
    return request({ url: `/bom-record/${id}`, method: 'get' })
}
export function getBomRecommendProductList(params) {
    return request({ url: '/bom-record/recommend-products', method: 'get', params })
}
export function handleBomRecord(id, data) {
    return request({ url: `/bom-record/${id}/handle`, method: 'post', data })
}
export function processBomRecord(id, data) {
    return request({ url: `/bom-record/${id}/process`, method: 'post', data })
}
export function quoteBomRecord(id, data) {
    return request({ url: `/bom-record/${id}/quote`, method: 'post', data })
}
export function recommendBomRecord(id, data) {
    return request({ url: `/bom-record/${id}/recommend`, method: 'post', data })
}
